import SupportIcon from "@mui/icons-material/Support";
import React from "react";
import { createSupportMailTo } from "../utils/customerSupport";
import Action from "./Action";
const SupportAction = (props) => {
    const handleClick = (event) => {
        const mailTo = createSupportMailTo();
        location.href = mailTo;
    };
    const action = {
        label: props.appModel.i18n("action.title.support"),
        onClick: handleClick,
        image: React.createElement(SupportIcon, null),
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Action, { action: action, appModel: props.appModel })));
};
export default SupportAction;
